import React, {Row, Col} from "react";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import {Button} from "antd";
import {InfoCircleOutlined, MessageOutlined} from "@ant-design/icons";
import {IconWithTooltip} from "../../DesignSystem/IconWithTooltip/IconWithTooltip";
import fileSize from "filesize";
import {isDisabled} from "../../../utils/security.utils";
import {HumanReadableDate} from "../../DesignSystem/Moment/HumanReadableDate";

export const buttons = (onSelectFile, onDeleteFile, record, user) => {

    return <div style={{textAlign: 'right'}}>
        <Button icon={<MessageOutlined/>} onClick={() => onSelectFile(record.id, record.name)} disabled={isDisabled(user)}>Use in chat</Button>
        {'   '}
        <Button type="text" icon={<DeleteOutlined/>} size="small" onClick={() => onDeleteFile(record.id, record.name)}/>
    </div>

}

export const columns = (user, onSelectFile, onDeleteFile) => [
    {
        title: 'Format',
        dataIndex: 'format',
        key: 'format',
        visible: true,
        width: 50,
        render: (_, record) => <img src={`/format/${record.format}.svg`} style={{width: '30px'}}/>
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        visible: true,
        render: (_, record) => <div style={{textAlign: 'left'}}>{record.name} <IconWithTooltip icon={<InfoCircleOutlined style={{width: '10px'}} />} title={`File size is ${fileSize(record.size)}`}/></div>
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        visible: true,
        render: (_, record) => <>{buttons(onSelectFile, onDeleteFile, record, user)}</>

    }
];
